export default {
  data() {
    return {
      windowSizeMixin: {
        width: null,
        height: null,
        lg: +(process.env.VUE_APP_WINDOW_SIZE_LG),
        md: +(process.env.VUE_APP_WINDOW_SIZE_MD),
        sm: +(process.env.VUE_APP_WINDOW_SIZE_SM),
        xs: +(process.env.VUE_APP_WINDOW_SIZE_XS),
      },
      timer: null
    }
  },
  methods: {
    check() {
      this.windowSizeMixin.width = window.innerWidth
      this.windowSizeMixin.height = window.innerHeight
      // console.log('do')
    },
    windowSizeHandleMixin() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.check()
      }, 300)
    }
  },
  created() {
    this.check()
    window.addEventListener("resize", this.windowSizeHandleMixin)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.windowSizeHandleMixin)
  }
}
